import axios from "../axiosInstance";
import React, { useEffect, useState } from 'react'

import { Navigate, redirect, useNavigate } from 'react-router-dom';

import logogsm from '../logogsm.png';

import { useDispatch, useSelector } from 'react-redux';
import { useCookies } from 'react-cookie';


export default function AgencyUserLogin() {

    const [cookies,setCookies]=useCookies(['cookieConsent']);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errorForm, setErrorForm] = useState({});
  const [error, setUError] = useState("");
  //const [lng,setLng]=useState(require("./../lng.json"))
  const navigate = useNavigate();
  const burl = process.env.REACT_APP_B_URL + "/agency-user/login";
  const baseUrl = process.env.REACT_APP_B_URL;
  const state = useSelector((state) => state);

 
  const logIn = async(e) => {
    
    e.preventDefault();
    setErrorForm({});
    let error1={};
    if (username == "") {
      error1.username = "Le champ est obligatoire!";
      setErrorForm(error1);
      return true;
    }else if (username.length < 4) {
      error1.username = "Minimum 4 caractères!";
      setErrorForm(error1);
      return true;
    }
    if (password == "") {
      error1.password = "Le champ est obligatoire!";
      setErrorForm(error1);
      return true;
    }else if (password.length < 8) {
      error1.password = "Minimum 8 caractères!";
      setErrorForm(error1);
      return true;
    }

   if(!cookies.cookieConsent) {
    setCookies('cookieConsent', true,{path: '/'})
   }
   axios.defaults.withCredentials = true;
    //console.log("bbbbbbbbbbbbbbbbb");
    setIsLoading(true);
    axios.post(burl,
      {
        userName: username,
        passWord: password
      }, {

      'Content-Type': 'application/json',
      accept: 'application/json',
    }).then(async(response) => {
      
      if (response) {
        
        if (!response.data.isError) {

          if(response.data.body!=null){
            sessionStorage.setItem('idAgency', response.data.body.fkIdAgency);
            sessionStorage.setItem('idAgencyUser', response.data.body.idAgencyUser);
            sessionStorage.setItem('codeAgency', response.data.body.agency?.code);
            sessionStorage.setItem('idUser', response.data.body.idAgencyUser);
            sessionStorage.setItem('userNameUser', response.data.body.login);
            //await postUserLog(baseUrl+"/userLogs/addUserLogs",'Connexion ','');
            if(response.data.body.isFirstLogin===true){
               navigate('/agency-change-password');
               return true;
            }
  
          }
          setInterval(()=>{

            axios.post(baseUrl+"/agency-user/refresh-token",
              {
                userName: username,
                passWord: password
              }, {
        
              'Content-Type': 'application/json',
              accept: 'application/json',
            }).then(async(response) => {
                  console.log(response.data);
            }).catch(async(error)=>{
              console.log(error)
            })
          },1000*60*8);

          navigate('/masterDepositByAgency');
        }else{
          setUError(response.data.msg);
        }
        setIsLoading(false);
        console.log(response.data)
        //getUserByLogin(username);
      }

    }).catch((err) => {
      setIsLoading(false);
      setUError("Une erreure s'est produite!!");
      
    })
  }
  

  return (
    <div className='contain'>


      <section className="vh-100" style={{ backgroundColor: '#2196F3' }}>
        <div className="container py-5 h-100">
          <div className="row d-flex justify-content-center align-items-center h-100">
            <div className="col col-xl-10">
              <div className="card" style={{ borderRradius: '1rem' }}>
                <div className="row g-0">
                  <div  style={{ 
                  backgroundImage: `url(${process.env.PUBLIC_URL + "/cg2.jpeg"})`, 
                  backgroundSize: "cover", 
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                }}
                  className="col-md-6 col-lg-5 d-none d-md-block d-fex justify-content-center align-items-center" 
                  // style={{  background: '#66AEDE' }}
                  >
                  {/* "https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/img1.webp" */}
                    {/* <img src={logogsm}
                      alt="login form" className="img-fluid d-block" 
                      style={{ borderRadius: '1rem 0 0 1rem', background: '#F9EEDC' }} /> */}
                  </div>
                  <div className="col-md-6 col-lg-7 d-flex align-items-center">
                    <div className="card-body p-4 p-lg-5 text-black">

                      <form onSubmit={logIn} action='POST'>

                        <div className="d-flex justify-content-center align-items-center mb-3 pb-1" >
                          <i className="fas fa-cubes fa-2x me-3" style={{ color: '#F9EEDC' }}></i>
                          {/* <span className="h1 fw-bold mb-0">NAFA</span> */}
                          {/* <h3>LOGO</h3> */}
                          <img src={logogsm}  width="45%"/>
                        </div>

                        <h5 className="fw-normal mb-3 pb-3" style={{ letterSpacing: '1px' }}>{state['instructionConnect']}</h5>

                        <div className="form-outline mb-4">
                          <input type="text" id="form2Example17" className="form-control form-control-lg" required onChange={(e) => setUsername(e.target.value)} value={username} />
                          {errorForm.username != "" && <p style={{ color: 'red' }}>{errorForm.username}</p>}
                          <label className="form-label" htmlFor="form2Example17">Pseudo</label>
                        </div>

                        <div className="form-outline mb-4">
                          <input type="password" id="form2Example27" className="form-control form-control-lg" required onChange={(e) => setPassword(e.target.value)} />
                          {errorForm.password != "" && <p style={{ color: 'red' }}>{errorForm.password}</p>}
                          <label className="form-label" htmlFor="form2Example27" >{state['Password']}</label>
                        </div>

                        <div className="pt-1 mb-4">
                          <button className="btn btn-primary btn-lg btn-block" type="submit">{isLoading?<span className="sr-only">En Charge...</span>:state['Login']}</button>
                        </div>
                        <br />
                        {
                          (error !== "") ? <p style={{ color: 'red' }}>{error}</p> : ""
                        }
                        
                        
                        <a href="#!" className="small text-muted">Terms of use.</a>
                        <a href="#!" className="small text-muted">Privacy policy</a>
                      </form>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
